document.querySelectorAll("form.load-indicator").forEach(form => {
	let firstErrorLabel = form.querySelector("label.error");
	if(firstErrorLabel) {
		let rect = firstErrorLabel.getBoundingClientRect();
		window.scroll({
			top: rect.top + window.scrollY,
			behavior: "smooth",
		});
	}

	form.addEventListener("submit", e => {
		if(form.classList.contains("submitted")) {
			e.preventDefault();
			return;
		}

		setTimeout(() => { form.classList.add("loading"); }, 500);
		form.classList.add("submitted");
	});

	let inputUpdateTimeout = null;
	form.querySelectorAll("input").forEach(input => {
		input.addEventListener("input", function(e) {
			if(inputUpdateTimeout !== null) {
				clearTimeout(inputUpdateTimeout);
				inputUpdateTimeout = -1;
			}
			inputUpdateTimeout = setTimeout(() => {
				inputUpdate.call(this, e);
			}, 500);
		});
	});

	function inputUpdate(e) {
		let label = this.closest("label");
		if(!label) {
			return;
		}

		if(label.classList.contains("error")) {
			label.classList.remove("error");
			label.querySelector(".error").style.visibility = "hidden";
		}
	}
});
